export default Object.freeze({
  New: 0,
  Exist: 1,
  InProviderCompany: 2,
  ActiveInSAEECorp: 3,
});
